import Drawer from '@/component/Drawer'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import RegisterMain from './RegisterMain'

const RegisterPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('uc')
  const registerPopupVisible = useStatePopup(PopupSelector.registerPopupVisible)

  const handleClose = () => {
    PopUpStore.setRegisterPopupVisible(false)
  }

  return (
    <Drawer
      visible={registerPopupVisible}
      zIndex={903}
      onClose={handleClose}
      lockScroll={true}
      destroyOnClose
      className="bg-primary-light"
      title={t('modalTitle.register')}
    >
      <div className="h-full px-md">
        <RegisterMain />
      </div>
    </Drawer>
  )
}

interface PropType {}

export default RegisterPopup
